import { Modal, Row, Col, Input } from "antd";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { api } from "../../utils/apiClient";

const ChurchModal = ({ open, onClose, data, onStatusChange }) => {
      const viewPermissions =
            useSelector((state) => state.permission.rolePermissions) || [];

      const [latitude, setLatitude] = useState("");
      const [longitude, setLongitude] = useState("");
      const [link, setLink] = useState("");
      const [name, setName] = useState("");

      // Pre-fill values when data changes
      useEffect(() => {
            if (data) {
                  setName(data.name || "");
                  setLatitude(data.latitude || "");
                  setLongitude(data.longitude || "");
                  setLink(data.link || "");
            }
      }, [data]);

      if (!data) return null;

      const Item = ({ label, value }) => (
            <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                        {label}
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 500, wordBreak: "break-word" }}>
                        {value || "-"}
                  </div>
            </div>
      );

      console.log("data.id = ", data.id);

      return (
            <Modal
                  title="Church Details"
                  open={open}
                  onCancel={onClose}
                  onOk={async () => {
                        try {
                              await api.put(`/church/${data.id}/location`, {
                                    name,
                                    latitude,
                                    longitude,
                                    link,
                              });

                              console.log("Updated:", latitude, longitude);

                              onClose();

                              if (onStatusChange) {
                                    onStatusChange();
                              }

                        } catch (error) {
                              console.error("Update failed:", error);
                        }
                  }}
                  width={700}
                  centered
            >
                  <Row gutter={[16, 10]}>
                        <Col xs={24} sm={12}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Church Name
                                    </div>
                                    <Input
                                          placeholder="Enter church name"
                                          value={name}
                                          onChange={(e) => setName(e.target.value)}
                                    />
                              </div>
                        </Col>

                        <Col xs={24} sm={12}>
                              <Item label="Place" value={data.place} />
                        </Col>

                        <Col xs={24} sm={12}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Latitude
                                    </div>
                                    <Input
                                          placeholder="Enter latitude"
                                          value={latitude}
                                          onChange={(e) => setLatitude(e.target.value)}
                                    />
                              </div>
                        </Col>

                        <Col xs={24} sm={12}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Longitude
                                    </div>
                                    <Input
                                          placeholder="Enter longitude"
                                          value={longitude}
                                          onChange={(e) => setLongitude(e.target.value)}
                                    />
                              </div>
                        </Col>

                        <Col xs={24}>
                              <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                                          Link
                                    </div>
                                    <Input
                                          placeholder="Enter link (Google Maps / Website)"
                                          value={link}
                                          onChange={(e) => setLink(e.target.value)}
                                    />
                              </div>
                        </Col>
                  </Row>
            </Modal>
      );
};

export default ChurchModal;